<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <article class="wrapper wrapper-content main-column full-column" v-if="searchOpen">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_report_on_2.png" alt="">
      {{$t('1on1ReportStr')}}
          </h1>
          <span class="info-right">
          </span>
        </div>
        <!-- /ViewTitleBox -->
        <div v-if="isLiteMode">
          <b-alert variant="danger" show>{{$t('liteIsStr')}}</b-alert>
        </div>
        <div v-else>
          <b-col cols="12">
            <b-col cols="4">
              <b-btn @click="setUserMe" variant="primary" class="mb-4">{{$t('displayMyselfStr')}}</b-btn>
            </b-col>
          </b-col>
          <!-- ViewTitleBox -->
          <div class="ibox-tools view-title">
              <h1 class="info-menu view-name">
                  <img src="static/img/assets/nav_people_on.png" alt="">
                  {{$t('searchUserStr')}}
              </h1>
              <span class="info-right">
              </span>
          </div>
          <!-- /ViewTitleBox -->
          <section class="animated fadeInRight">
            <!-- 1on1item -->
            <div class="ibox">
              <div class="ibox-content">
                  <!-- ユーザー検索ボックス -->
                  <div class="ibox-title search-box">
                    <div class="row">
                      <div class="col-sm-12">
                        <form @submit.prevent>
                          <div class="input-group">
                            <input v-model="searchText" type="text" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="ibox-content search-resultview">
                    <ul v-if="searchText == ''">
                      <li><label>{{$t('checkUserStrType')}}</label></li>
                      <li v-if="this.getVisitedUsers.length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>
                      <li v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId" class="result-box">
                        <div class="cursor" @click="setUserKey(user.userId)">
                          <span class="search-userimg">
                            <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                          <div class="search-userinfo">
                            <span class="search-username">{{ user.userInfo.userName }}</span>
                            <span class="search-userdept">{{ user.userInfo.dept }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul v-else>
                      <li><label>{{$t('searchResuleStrType')}}</label></li>
                      <li v-if="Object.keys(this.getUsersBySearchText).length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>
                        <li v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo && key !== getUserId" class="result-box">
                          <template>
                            <div class="cursor" @click="setUserKey(key)">
                              <span class="search-userimg">
                                <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                              </span>
                              <div class="search-userinfo">
                                <span class="search-username">{{ user.userInfo.userName }}</span>
                                <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                <span class="search-userbio">{{ user.userInfo.userBio }}</span>
                              </div>
                            </div>
                          </template>
                        </li>
                      </ul>
                    </div>
                    <!-- /ユーザー検索ボックス -->
              </div>
            </div>
            <!-- /1on1item -->
          </section>
        </div>
      </article>
      <!-- MainView -->
      <article class="wrapper wrapper-content main-column" v-if="!searchOpen">
        <b-row>
          <b-col cols="4" class="text-center">
            <b-btn @click="onClickBack" type="button" variant="primary" class="mb-4">{{$t('selectUserStr')}}</b-btn>
          </b-col>
          <b-col cols="8" class="bg-white py-2">
            <span class="search-userimg">
              <img v-if="targetUserInfo.userIcon" :src="targetUserInfo.userIcon" alt="image" class="img-circle">
              <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
            </span>
            <div class="search-userinfo">
              <span class="search-username">{{ targetUserInfo.userName }}</span>
              <span class="search-userbio">{{ targetUserInfo.userBio }}</span>
            </div>
          </b-col>
        </b-row>
        <b-col cols="12">
          <div class="input-group date my-4">
            <span class="input-group-addon text-right"><i class="fa fa-calendar" @click="openPickerFrom"></i></span>
            <datepicker
              :language="datepickerLocale[checkLanguage]"
              :format='format'
              :typeable='true'
              placeholder="Select From Date"
              v-model="fromDate"
              ref="programaticOpenFrom"></datepicker>
            <span>〜</span>
            <span class="input-group-addon text-right"><i class="fa fa-calendar" @click="openPickerTo"></i></span>
            <datepicker
              :language="datepickerLocale[checkLanguage]"
              :format='format'
              :typeable='true'
              placeholder="Select To Date"
              v-model="toDate"
              ref="programaticOpenTo"></datepicker>
          </div>
        </b-col>
        <section class="animated fadeInUp">
          <b-col cols="12">
            <b-list-group class="oooList">
              <template v-for="(item1on1, idx) in reports.list1on1s">
                <b-list-group-item :key="idx" :active="targetDate === item1on1.date" @click="selectDate(item1on1.date)" v-if="isBetweenDate(item1on1.date)">
                  <div>
                    <h4 class="date-label">
                      <!--<b-btn variant="outline-warning" @click="jump(item1on1, '1on1s')" class="btn-open-detail">Jump</b-btn>-->
                      {{ ymdSlash(item1on1.date) }}
                    </h4>
                    <report-1on1-item :item="item1on1" />
                  </div>
                </b-list-group-item>
              </template>
            </b-list-group>
          </b-col>
        </section>
      </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <article class="sub-content-wrap">
          <section class="animated fadeInRight">
            <b-col cols="12" class="p-0">
              <template v-for="(itemOkr, idx) in reports.listOkrs" v-if="targetDate >= itemOkr.startDate && targetDate <= itemOkr.dueDate">
                <b-list-group-item :key="idx">
                  <report-1on1-list-okr-item :item="setProgressFromDate(itemOkr)" v-on:open-detail="openDetail" :targetDate="targetDate"/>
                </b-list-group-item>
              </template>
            </b-col>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Report1on1Item from '@/components/Report/Report1on1Item'
import Report1on1ListOkrItem from '@/components/Report/Report1on1ListOkrItem'
import {i18n, liteMode} from '@/main.js'
import {ja, en, zh} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'Report1on1s',
  components: {
    Report1on1Item,
    Report1on1ListOkrItem,
    Datepicker
  },
  data: function () {
    return {
      isLiteMode: liteMode,
      isManager: false,
      open: false,
      href: location.href,
      title: document.title,
      targetUser: '',
      targetInfo: {},
      targetDate: '',
      dates: [],
      searchText: '',
      searchOpen: true,
      // fromDate: new Date(),
      // toDate: new Date(),
      fromDate: moment()
        .subtract(1, 'month')
        .toDate(),
      toDate: moment().toDate(),
      format: 'yyyy/MM/dd',
      datepickerLocale: {
        ja: ja,
        en: en,
        zh_tr: zh
      }
    }
  },
  getters: {},
  computed: {
    isMatchPath () {
      return this.$route.name === 'Report1on1s'
    },
    ...mapGetters(['getUserId', 'getCurrentUser']),
    ...mapGetters('okrs/', [
      'getRelationInfo'
    ]),
    ...mapGetters('keyResults/', [
      'getCurrentKeyresults',
      'getKeyresultById',
      'getKeyresultsByUserId',
      'getKeyresultsByParentObjId'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByUserId',
      'getObjectiveById',
      'getCurrentObjectives'
    ]),
    ...mapGetters('ones/', ['getCurrent1on1s', 'get1on1sByUserId']),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserInfoById'
    ]),
    ...mapGetters('_meta/', [
      'getMetaProgress',
      'getMetaIsDeleted'
    ]),
    checkLanguage () {
      return i18n.locale
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getUsers
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(
          Object.keys(currentUser.visitHistory)
        )
        let sortedRecentlyCheckedUsers = visitHistory
          .sort((a, b) => {
            return currentUser.visitHistory[b] - currentUser.visitHistory[a]
          })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => {
            return recentlyCheckedUsers[x]
          })
          .filter(x => { return !!x })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    reports () {
      console.log(this.targetUser)
      const userId = this.targetUser
      console.log('reports:userId', userId)
      let reports = {
        dates: [],
        list1on1s: [],
        listOkrs: []
      }
      let list1on1s = []
      let curr1on1s = this.get1on1sByUserId(userId)
      // console.log('list1on1s:', curr1on1s)
      if (undefined !== curr1on1s) {
        // console.log('list1on1s:', curr1on1s, Object.keys(curr1on1s))
        for (let k of Object.keys(curr1on1s)) {
          // console.log('list1on1s:for', k, curr1on1s[k])
          if (k === '.key') continue
          let c = curr1on1s[k]
          c.itemId = k
          list1on1s.push(c)
        }
        // console.log('list1on1s', list1on1s)
        reports.list1on1s = list1on1s.sort((a, b) => {
          if (a.date < b.date) return -1
          if (a.date > b.date) return 1
          return 0
        })
      }
      reports.dates = reports.list1on1s.map(x => {
        return x.date
      })
      // console.log('dates', reports.dates)
      if (!this.targetDate) {
        this.targetDate = reports.dates.length ? reports.dates[0] : ''
      }

      const metaProgress = this.getMetaProgress(userId)
      let listOkrs = []
      // let currOkrs = getObjectivesByUser(userId)
      // let currOkrs = this.$store.getters.getCurrentObjectives
      let currObjs = this.getObjectivesByUserId(userId)
      let currKrs = this.getKeyresultsByUserId(userId)
      if (undefined !== currObjs) {
        // console.log('listOkrs:', currObjs, Object.keys(currObjs))
        for (let k of Object.keys(currObjs)) {
          if (k === '.key') continue
          // console.log('listOkrs:for', k, currObjs[k])
          let c = currObjs[k]
          c.itemId = k
          if (!(c.hasOwnProperty('dueDate'))) {
            continue
          }
          c.date = moment(c.createdAt * 1000).format('YYYY-MM-DD')
          c.dueDate = c.dueDate.replace(/\//g, '-')
          if (c.hasOwnProperty('startDate')) {
            c.startDate = c.startDate.replace(/\//g, '-')
          } else {
            c.startDate = c.date
          }
          c.progressTransition =
            (metaProgress.objectives && metaProgress.objectives[k]) || {}
          if (c.keyresults) {
            // console.log('c.keyresults', c.keyresults, c)
            for (let kr of Object.keys(c.keyresults)) {
              if (kr === '.key') continue
              // console.log('listOkrs:for KR', kr, c.keyresults[kr])
              if (currKrs[kr]) {
                if (!(currKrs[kr].hasOwnProperty('dueDate'))) {
                  delete c.keyresults[kr]
                  continue
                }
                // console.log('fuckin jap!', currKrs[kr])
                c.keyresults[kr] = currKrs[kr]
                c.keyresults[kr].itemId = kr
                c.keyresults[kr].date = moment(
                  c.keyresults[kr].createdAt * 1000
                ).format('YYYY-MM-DD')
                c.keyresults[kr].dueDate = c.keyresults[kr].dueDate.replace(/\//g, '-')
                if (c.keyresults[kr].hasOwnProperty('startDate')) {
                  c.keyresults[kr].startDate = c.keyresults[kr].startDate.replace(/\//g, '-')
                } else {
                  c.keyresults[kr].startDate = c.keyresults[kr].date
                }
                c.keyresults[kr].progressTransition =
                  (metaProgress.keyresults && metaProgress.keyresults[kr]) ||
                  {}
              } else {
                delete c.keyresults[kr]
              }
              // console.log('hohohoho', c.keyresults[kr], currKrs[kr])
            }
          }
          listOkrs.push(c)
        }
        // console.log('listOkrs', listOkrs)
        listOkrs = listOkrs.sort((a, b) => {
          if (a.createdAt < b.createdAt) return -1
          if (a.createdAt > b.createdAt) return 1
          return 0
        })
        reports.listOkrs = listOkrs
      }
      console.log('listOkrs', listOkrs)
      return reports
    }
  },
  created () {
    // this.$root.$on('bv::scrollspy::activate', this.onActivate)
  },
  mounted () {
    console.info('Report1on1s: mounted.')
    this.$store.dispatch('_meta/GET_META_PROGRESS')
  },
  destroyed () {
    console.info('Report1on1s: destroyed.')
    this.$store.dispatch('_meta/UNBIND_META_PROGRESS')
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    ymdSlash: function (date) {
      const ymd = moment(date).format('YYYY/MM/DD')
      return (ymd === 'Invalid date') ? '----/--/--' : ymd
    },
    openPickerFrom: function () {
      this.$refs.programaticOpenFrom.showCalendar()
    },
    openPickerTo: function () {
      this.$refs.programaticOpenTo.showCalendar()
    },
    selectDate (date) {
      console.log('selectDate: ', date)
      this.targetDate = date
    },
    isBetweenDate (date) {
      // console.log('date', date, Date.parse(date) < Date.parse(this.toDate))
      return (
        Date.parse(this.fromDate) <= Date.parse(date) &&
        Date.parse(date) <= Date.parse(this.toDate)
      )
    },
    setProgressFromDate (item) {
      console.log('setProgressFromDate: ', item)
      let p = 0
      let d = this.targetDate
      let progressTransition = (item && item.progressTransition) || {}
      console.log('setProgressFromDate:progressTransition', progressTransition, d)
      if (d) {
        Object.keys(progressTransition).some(k => {
          // console.log(p, k, d)
          if (k > d) return true
          p = progressTransition[k]
          console.log('setProgress: ', p)
        })
      }
      if (item === 1) {
        // TODO なぜかitem === 1となって下のitem.progress = pが動かない場合がある
        // ↓の item.keyresults[kr] が 1 になっている（ものが再帰で呼ばれた）時に起きていると思われる
        console.log('1dayo')
        alert('[DEBUG] item === 1')
      } else {
        // console.log('1janaiyo', item)
        item.progress = p
      }
      if (item.keyresults) {
        for (let kr of Object.keys(item.keyresults)) {
          item.keyresults[kr] = this.setProgressFromDate(item.keyresults[kr])
        }
      }
      return item
    },
    onClickBack () {
      this.open = false
      this.searchOpen = true
    },
    setUserKey (userKey) {
      this.targetUser = userKey
      this.open = true
      this.searchOpen = false
      this.targetUserInfo = this.getUserInfoById(userKey)
      if (this.getUserId !== userKey) { this.setVisit(userKey) }
    },
    setUserMe () {
      this.setUserKey(this.getUserId)
    },
    jump: function (value, itemType) {
      console.log(' this.$emit(get-detail)', value, itemType)
      value.type = {}
      value.type[itemType] = value.itemId || ''
      this.openDetail(value)
    },
    openDetail: function (value) {
      console.log('openDetail:', value)
      console.log('openDetail:', { userId: this.targetUser, item: value.type })
      let detailPrms = { name: 'User', params: { userId: this.targetUser, item: value.type } }
      if (value.type['1on1s']) {
        detailPrms.params.content = [ 0 ]
      }
      console.log('Report1on1s.vue:openDetail', detailPrms)
      this.$router.push(detailPrms)
    }
  }
}
</script>

<style lang="scss" scoped>
h4.date-label {
  font-size: 100%;
}
.sub-content-wrap {
  overflow-y: auto
}
.listgroup-date {
  transition: 1s
}
.oooList {
  .list-group-item {
    transition: .2s;
    .btn-open-detail {
      display: none;
      position: absolute;
      margin: auto;
      right: 1.2em;
      z-index: 999;
    }
    &:hover {
      transition: .2s;
      background-color: #90d6ec;
      border-color: #90d6ec;
      .btn-open-detail {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/Report1on1s.vue